module.exports = __webpack_public_path__ + "img/title-bg.e70d4930.png";